import type { SVGProps } from "react";

export const CalenderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}>
    <path
      fill={props.fill || "#4D4D4D"}
      d="M4.248 7.997a.748.748 0 1 0 0-1.497.748.748 0 0 0 0 1.497Zm.749 1.751a.748.748 0 1 1-1.497 0 .748.748 0 0 1 1.497 0ZM7 7.997A.748.748 0 1 0 7 6.5a.748.748 0 0 0 0 1.497Zm.749 1.751a.748.748 0 1 1-1.497 0 .748.748 0 0 1 1.497 0Zm2-1.751a.748.748 0 1 0 0-1.497.748.748 0 0 0 0 1.497ZM13 3.5A2.5 2.5 0 0 0 10.5 1h-7A2.5 2.5 0 0 0 1 3.5v7A2.5 2.5 0 0 0 3.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-7ZM2 5h10v5.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 2 10.5V5Zm1.5-3h7A1.5 1.5 0 0 1 12 3.5V4H2v-.5A1.5 1.5 0 0 1 3.5 2Z"
    />
  </svg>
);
